import React from 'react';
import '../style.css';

const RocklandNews = () => {
  return (
    <div className="four-images-container">
      {/* Row 1 - 4 images */}
      <div className="images-row">
        <div className="image-box">
          <img src="news.png" alt="News 1" />
        </div>
        <div className="image-box">
          <img src="news1.png" alt="News 2" />
        </div>
        <div className="image-box">
          <img src="new2.png" alt="News 3" />
        </div>
      </div>

      {/* Row 2 - 3 images */}
      <div className="images-row">
        <div className="image-box">
          <img src="new3.png" alt="News 4" />
        </div>
        <div className="image-box">
          <img src="new5.png" alt="News 5" />
        </div>
        <div className="image-box">
          <img src="new5.png" alt="News 6" />
        </div>
      </div>

      {/* Row 3 - 3 images */}
      <div className="images-row">
        <div className="image-box">
          <img src="new6.png" alt="News 7" />
        </div>
        <div className="image-box">
          <img src="new7.png" alt="News 8" />
        </div>
        <div className="image-box">
          <img src="new8.png" alt="News 9" />
        </div>
      </div>
    </div>
  );
};

export default RocklandNews;